// react library imports
import moment from "moment";

// import from auth apis
import { muesApiSlice } from "../authentication/authentication";

// import from redux store
import { addActiveTerm, addTermList } from "Redux/class/academicPlan";

export const academicPlanApi=muesApiSlice.injectEndpoints({
    endpoints: builder =>({
        // list of query
        getAcademicPlan : builder.query({
            query : (queryParams)=>({
                url: 'academic-year-plan',
                method: 'GET',
                params: queryParams,
            }),
            providesTags:(result, error, arg)=>[
                { type: "academicPlan", id: "LIST" },
            ]
        }),
        getTermList : builder.query({
            query : (queryParams)=>({
                url: 'term',
                method: 'GET',
                params: queryParams,
            }),
            providesTags:()=>[
                {type:"termList", id:"LIST"}
            ],        
            async onQueryStarted(arg, { dispatch, queryFulfilled, getState }){
                try {
                    const {data} = await queryFulfilled;
                    
                    // Get the current activeTeacher from the state
                    const state = getState();
                    const  currentTerm = state.academicPlan.other.activeTerm;
                    dispatch(addTermList(data))
                    
                    if (currentTerm) {                        
                        // Check if the activeTeacher is still in the updated list
                        const updateActiveTerm = data?.find(
                          (term) => term.id === currentTerm.id
                        );
                        
                        // If found, update the activeTeacher in the state
                        if (updateActiveTerm) {
                          dispatch(addActiveTerm(updateActiveTerm));
                        }else{
                            if (data?.length > 0) {
                                dispatch(addActiveTerm(data[0]));
                            }else{
                                dispatch(addActiveTerm(null))
                            }
                        }
                    }else{
                        if (data?.length > 0) {
                            dispatch(addActiveTerm(data[0]));
                        }else{
                            dispatch(addActiveTerm(null))
                        }
                    }
                } catch (error) {
                    console.log('Error while fetching term list:', error);
                }
            },
            transformResponse: (result) => {   
                if (result?.term) return result?.term
                return result?.terms?.map(term => {
                    return {
                        ...term,
                        start_date: moment(term.start_date).format("DD MMM YYYY"),
                        end_date: moment(term.end_date).format("DD MMM YYYY")
                    };
                });
            },
        }),
        getTopicList : builder.query({
            query : (queryParams)=>({
                url: 'topic',
                method: 'GET',
                params: queryParams,
            }),
            providesTags:()=>[
                {type:"topicList", id:"LIST"}
            ]
        }),
        getSubtopics : builder.query({
            query : (queryParams)=>({
                url: 'sub-topic',
                method: 'GET',
                params: queryParams,
            }),
            providesTags:()=>[
                {type:"subtopics", id:"LIST"}
            ]
        }),
        getSubTopicList : builder.query({
            query : (queryParams)=>({
                url: `topic/${queryParams}`,
                method: 'GET',
            }),
            providesTags:(result, error, arg)=>[
                {type:"subTopicList", id:"LIST"}
            ]
        }),

        // list of mutation of academic plan
        addNewAcademicPlan : builder.mutation({
            query: (requestBody) => ({
                url: 'academic-year-plan',
                method: 'POST',
                body: requestBody,
              }),
            invalidatesTags:(result, error, arg)=>[
                {type:"academicPlan", id:"LIST"}
            ]
        }),
        editAcademicPlan : builder.mutation({
            query: (requestBody) => ({
                url: 'academic-year-plan',
                method: 'PUT',
                body: requestBody,
              }),
            invalidatesTags:(result, error, arg)=>[
                {type:"academicPlan", id:"LIST"},
            ]
        }),
        deleteAcademicPlan : builder.mutation({
            query: (requestBody) => ({
                url: 'academic-year-plan',
                method: 'DELETE',
                body: requestBody,
              }),
            invalidatesTags:()=>[
                {type:"academicPlan", id:"LIST"},
            ]
        }),

        // list of mutation of term
        addNewTerm : builder.mutation({
            query: (requestBody) => ({
                url: 'term',
                method: 'POST',
                body: requestBody,
              }),
            invalidatesTags:(result, error, arg)=>[
                {type:"termList", id:"LIST"}
            ]
        }),
        addBulkInTerm : builder.mutation({
            query: (requestBody) => ({
                url: 'post-term-list',
                method: 'POST',
                body: requestBody,
              }),
            invalidatesTags:(result, error, arg)=>[
                {type:"termList", id:"LIST"}
            ]
        }),
        editTerm : builder.mutation({
            query: (requestBody) => ({
                url: 'term',
                method: 'PUT',
                body: requestBody,
              }),
            invalidatesTags:(result, error, arg)=>[
                {type:"termList", id:"LIST"}
            ]
        }),
        deleteTerm : builder.mutation({
            query: (requestBody) => ({
                url: 'term',
                method: 'DELETE',
                body: requestBody,
              }),
            invalidatesTags:(result, error, arg)=>[
                {type:"termList", id:"LIST"}
            ]
        }),

        // list of mutation of topic
        addNewTopic : builder.mutation({
            query: (requestBody) => ({
                url: 'topic/',
                method: 'POST',
                body: requestBody,
              }),
            invalidatesTags:(result, error, arg)=>[
                {type:"topicList", id:"LIST"},
                {type:"subTopicList", id:"LIST"}
            ]
        }),
        addBulkInTopic : builder.mutation({
            query: (requestBody) => ({
                url: 'post-topic-list',
                method: 'POST',
                body: requestBody,
              }),
            invalidatesTags:(result, error, arg)=>[
                {type:"topicList", id:"LIST"},
                {type:"subTopicList", id:"LIST"}
            ]
        }),
        editTopic : builder.mutation({
            query: (requestBody) => ({
                url: 'topic/',
                method: 'PUT',
                body: requestBody,
              }),
            invalidatesTags:(result, error, arg)=>[
                {type:"topicList", id:"LIST"},
                {type:"subTopicList", id:"LIST"}
            ]
        }),
        deleteTopic : builder.mutation({
            query: (requestBody) => ({
                url: 'topic/',
                method: 'DELETE',
                body: requestBody,
              }),
            invalidatesTags:(result, error, arg)=>[
                {type:"topicList", id:"LIST"},
                {type:"subTopicList", id:"LIST"}
            ]
        }),

        // validate mutation
        validateTerm : builder.mutation({
            query: (requestBody) => ({
                url: 'validate-term-list',
                method: 'POST',
                body: requestBody,
              }),
        }),
        validateTopic : builder.mutation({
            query: (requestBody) => ({
                url: 'validate-topic-list',
                method: 'POST',
                body: requestBody,
              }),
        }),
    })
})

export const { useGetAcademicPlanQuery, useGetTermListQuery, useGetTopicListQuery,
    useAddNewAcademicPlanMutation, useEditAcademicPlanMutation, useDeleteAcademicPlanMutation,
    useAddNewTermMutation, useEditTermMutation, useDeleteTermMutation, useAddNewTopicMutation,
    useEditTopicMutation, useDeleteTopicMutation, useGetSubTopicListQuery,useAddBulkInTermMutation,
    useAddBulkInTopicMutation, useValidateTermMutation, useValidateTopicMutation, useGetSubtopicsQuery
}=academicPlanApi